module.exports = "/images/so.svg?b60f52c2e3188e07b845bf097e6a225c";